<template>
    <div>
        <el-row :gutter="20">
            <el-col :span="8">
                <el-form-item label="จังหวัด" label-width="70px" :prop="nameCheck.provi" >
                    <el-select v-model="info.province" placeholder="กรุณาเลือกจังหวัด" @change="provinceSelected">
                        <el-option
                        v-for="item in provincearray"
                        :key="item"
                        :label="item"
                        :value="item"
                        autocomplete="off"
                        >
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-col>
            <el-col :span="8">
                <el-form-item label="อำเภอ" label-width="55px" :prop="nameCheck.distr" class="labelForm" >
                    <el-select v-model="info.district" placeholder="กรุณาเลือกอำเภอ" @change="districtSelected" :disabled="districtArray.length <= 0">
                        <el-option
                        v-for="item in districtArray"
                        :key="item"
                        :label="item"
                        :value="item"
                        autocomplete="off"
                        >
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-col>
            <el-col :span="8">
                <el-form-item label="ตำบล" label-width="55px" :prop="nameCheck.subDist" class="labelForm" >
                    <el-select v-model="info.subDistrict" placeholder="กรุณาเลือกตำบล" @change="subDistrictSelected" :disabled="subDistrictArray.length <= 0">
                        <el-option
                        v-for="item in subDistrictArray"
                        :key="item"
                        :label="item"
                        :value="item"
                        >
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-col>
        </el-row>
        <el-form-item label="รหัสไปรษณีย์ร้านค้า" class="labelForm">
            <el-input v-model="info.zipcode" disabled></el-input>
        </el-form-item>
    </div>
</template>

<script>
export default {
    name: 'province',
    props: {
        info: {
            type: Object
        },
        provincearray: {
            type: Array,
            default: null
        },
        name: {
            type: Object,
            default: () => {
                return {
                    provi: '',
                    distr: '',
                    subDist: ''
                }
            }
        },
        geo: {
            type: Object
        }
    },
    data () {
        return {
            districtArray: [],
            subDistrictArray: [],
            geoForm: this.geo,
            nameCheck: this.name
        }
    },
    mounted () {
        this.$nextTick(() => {
            if (this.info.province && this.info.district) {
                this.checkDistrictArray(this.info.province)
                this.checkSubDistrictArray(this.info.district)
            }
        })
    },
    methods: {
        checkDistrictArray (val) {
            this.districtArray = []
            if (val !== '') {
                for (let district in this.geoForm[val]) {
                    this.districtArray.push(district)
                }
            }
        },
        checkSubDistrictArray (val) {
            this.subDistrictArray = []
            if (val !== '') {
                for (let subDistrict in this.geoForm[this.info.province][val]) {
                    this.subDistrictArray.push(subDistrict)
                }
            }
        },
        provinceSelected (val) {
            this.info.district = ''
            this.info.subDistrict = ''
            this.info.zipcode = ''
            if (val) {
                this.checkDistrictArray(val)
            }
        },
        districtSelected (val) {
            this.info.subDistrict = ''
            this.info.zipcode = ''
            if (val) {
                this.checkSubDistrictArray(val)
            }
        },
        subDistrictSelected (val) {
            if (val !== '') {
                this.info.zipcode = String(this.geoForm[this.info.province][this.info.district][val])
            }
        }
    }
}
</script>
